import useAuthStore from '../store/authStore';

/**
 * Returns activeBranchId for use in API calls and forms
 * Usage: const { branchId, activeBranch, branches } = useBranch();
 */
export function useBranch() {
  const { activeBranch, user, getActiveBranchId } = useAuthStore();
  const branches = user?.branches || [];
  const branchId = getActiveBranchId();

  return {
    branchId,
    activeBranch: activeBranch || branches[0] || null,
    branches,
    hasBranch: !!branchId,
  };
}

export default useBranch;
